import memoizeOne from 'memoize-one';

import { Action, ActionType } from './Action';
import { Module } from './Module';

export interface State {
	request: Promise<{ items: Array<{ id: string }> }> | null;
	isFetching: boolean;
	module: Module | null;
	versions: Array<{ id: string }> | null;
}

export default function reducer(state: State = createState(), action: Action): State {
	switch (action.type) {
		case ActionType.request:
			return {
				...state,
				request: action.request,
				isFetching: true,
				module: action.module,
				versions: null,
			};

		case ActionType.receive:
			return state.request === action.request
				? {
						...state,
						request: action.versions !== null ? action.request : null,
						isFetching: false,
						versions: action.versions,
				  }
				: state;

		case ActionType.prune:
			return createState();

		default:
			return state;
	}
}

function createState(): State {
	return {
		request: null,
		isFetching: false,
		module: null,
		versions: null,
	};
}

export const selectReferenceBasketVersions = memoizeOne(
	<Version extends { id: string; sinceDate: Date; order: number; description: string; name: string }>(
		state: State,
		module: Module
	): Version[] | null => {
		if (state.module !== module || state.versions === null) {
			return null;
		}

		const versions = [...state.versions] as Version[];
		versions.sort((a, b) => b.sinceDate.getTime() - a.sinceDate.getTime());
		return versions;
	}
);
